import React, { Component } from 'react';
import workdaylogo from '../../assets/workdaylogo.png';
import Dropdown from '../content/Dropdown';
class Header extends Component {
    render() {
        return (
            <div className="headercontent">
                <img className="headerimg" src={workdaylogo} alt="Smiley face"></img>
            </div>
        );
    }
}
export default Header;